// This file is generated by
// services/coaches/cmd/school_picker/generate_typescript.
// Do not edit directly.

// Map of ISO-3166-2 codes to the names of admin level one entities.
export const ADMIN_LEVEL_ONE_CODES_TO_NAMES: Record<string, string> = {
    "01": "LAI CHÂU",
    "02": "LÀO CAI",
    "06": "YÊN BÁI",
    "07": "TUYÊN QUANG",
    "13": "QUẢNG NINH",
    "14": "HOÀ BÌNH",
    "20": "THÁI BÌNH",
    "21": "THANH HOÁ",
    "25": "QUẢNG TRỊ",
    "39": "ĐỒNG NAI",
    "47": "KIÊN GIANG",
    "57": "BÌNH DƯƠNG",
    "68": "PHÚ THỌ",
    "70": "VĨNH PHÚC",
    HN: "HÀ NỘI",
};

// Map of the administrative levels used in country.
//
// Keys are the ISO-3166-2 codes of the admin-level-one entities.
// Values are the names of the localities within those entities.
export const ADMIN_LEVELS: Record<string, string[]> = {
    "01": ["THAN UYÊN"],
    "02": ["BẢO THẮNG", "TP LÀO CAI"],
    "06": ["MÙ CANG CHẢI"],
    "07": [
        "CHIÊM HOÁ",
        "HÀM YÊN",
        "LÂM BÌNH",
        "NA HANG",
        "SƠN DƯƠNG",
        "TP TUYÊN QUANG",
        "YÊN SƠN",
    ],
    "13": ["TX ĐÔNG TRIỀU"],
    "14": [
        "CAO PHONG",
        "KIM BÔI",
        "LƯƠNG SƠN",
        "LẠC SƠN",
        "LẠC THUỶ",
        "LẠC THỦY",
        "MAI CHÂU",
        "TP HOÀ BÌNH",
        "TÂN LẠC",
        "YÊN THỦY",
        "ĐÀ BẮC",
    ],
    "20": [
        "HƯNG HÀ",
        "KIẾN XƯƠNG",
        "QUỲNH PHỤ",
        "THÁI THUỴ",
        "THÁI THỤY",
        "TIỀN HẢI",
        "TP THÁI BÌNH",
        "VŨ THƯ",
        "ĐÔNG HƯNG",
    ],
    "21": [
        "BÁ THƯỚC",
        "CẨM THUỶ",
        "CẨM THỦY",
        "HOẰNG HOÁ",
        "HÀ TRUNG",
        "HẬU LỘC",
        "LANG CHÁNH",
        "MƯỜNG LÁT",
        "NGA SƠN",
        "NGỌC LẶC",
        "NHƯ THANH",
        "NHƯ XUÂN",
        "NÔNG CỐNG",
        "QUAN HOÁ",
        "QUAN SƠN",
        "QUẢNG XƯƠNG",
        "THIỆU HOÁ",
        "THƯỜNG XUÂN",
        "THẠCH THÀNH",
        "THỌ XUÂN",
        "TP SẦM SƠN",
        "TP THANH HOÁ",
        "TRIỆU SƠN",
        "TX BỈM SƠN",
        "TX NGHI SƠN",
        "VĨNH LỘC",
        "YÊN ĐỊNH",
        "ĐÔNG SƠN",
    ],
    "25": [
        "CAM LỘ",
        "GIO LINH",
        "HƯỚNG HOÁ",
        "HẢI LĂNG",
        "TP ĐÔNG HÀ",
        "TRIỆU PHONG",
        "TX QUẢNG TRỊ",
        "VĨNH LINH",
        "ĐAKRÔNG",
    ],
    "39": [
        "CẨM MỸ",
        "LONG THÀNH",
        "NHƠN TRẠCH",
        "THỐNG NHẤT",
        "TP BIÊN HOÀ",
        "TP LONG KHÁNH",
        "TRÀNG BOM",
        "TÂN PHÚ",
        "VĨNH CỬU",
        "XUÂN LỘC",
        "ĐỊNH QUÁN",
    ],
    "47": [
        "AN BIÊN",
        "AN MINH",
        "CHÂU THÀNH",
        "GIANG THÀNH",
        "GIỒNG RIỀNG",
        "GÒ QUAO",
        "HÒN ĐẤT",
        "KIÊN HẢI",
        "KIÊN LƯƠNG",
        "TP HÀ TIÊN",
        "TP PHÚ QUỐC",
        "TP RẠCH GIÁ",
        "TÂN HIỆP",
        "U MINH THƯỢNG",
        "VĨNH THUẬN",
    ],
    "57": [
        "BÀU BÀNG",
        "BẮC TÂN UYÊN",
        "BẾN CÁT",
        "DẦU TIẾNG",
        "PHÚ GIÁO",
        "TP BẾN CÁT",
        "TP DĨ AN",
        "TP THUẬN AN",
        "TP THỦ DẦU MỘT",
        "TP TÂN UYÊN",
    ],
    "68": [
        "CẨM KHÊ",
        "HẠ HOÀ",
        "LÂM THAO",
        "LƯƠNG SƠN",
        "PHÙ NINH",
        "TAM NÔNG",
        "THANH BA",
        "THANH SƠN",
        "THANH THUỶ",
        "TP VIỆT TRÌ",
        "TX PHÚ THỌ",
        "TÂN SƠN",
        "YÊN LẬP",
        "ĐOAN HÙNG",
    ],
    "70": ["VĨNH YÊN"],
    HN: [
        "BA VÌ",
        "LỚP HỌC MỞ KAV",
        "MÊ LINH",
        "MỸ ĐỨC",
        "PHÚ XUYÊN",
        "QUẬN BA ĐÌNH",
        "QUẬN HOÀNG MAI",
    ],
};
